import React from 'react'
import {Heading, Text, Breadcrumb, Link } from 'base-ui'
import Highlighter from './Highlight'
import { PageWrapper } from './PageWrapper'
import { Breadcrumb as BreadcrumbExample } from '../examples/Breadcrumbs'


const Breadcrumbs = () => {
    const [paths] = React.useState([
        {
            url: '#',
            label: 'link 1',
        },
        {
            url: '#',
            label: 'Link 2',
        },
        {
            url: '#',
            label: 'Link 3',
        }
    ])

  return (
    <PageWrapper title="Breadcrumbs" isResponsive={true}>
        <Text size="md">
            Breadcrumbs, or a breadcrumb navigation, can help enhance how users navigate to previous page levels of a site, 
            especially if that site has many pages or products. Used more frequently when there are 3 or more nested navigation items.
            The Breacrumb component is based on the <Link href="/#/typography/links">Link Component</Link> and it is responsive.
        </Text>
        {/* <Heading size="h3">Sizes</Heading> */}
        <Breadcrumb paths={paths} className="py-4"/>
        <Heading size="h3">Usage</Heading>
        <div className="py-4">
            <Highlighter code={BreadcrumbExample} language='jsx' />
        </div>
    </PageWrapper>
  )
}

export default Breadcrumbs
